var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.async-iterator.js
// module id = 806
// module chunks = 49